import classNames from 'classnames';
import styles from './PaymentCards.module.scss';

const PaymentCards = ({ theme = 'dark' }: { theme?: 'light' | 'dark' }) => {
  return (
    <div className={classNames(styles.wrapper, styles[theme])}>
      <div className={styles.title}>
        <img src={`/icons/padlock${ theme === "dark" ? "-light" : "" }.svg`} alt="Padlock" />
        <span>Pay securely with</span>
      </div>
      <div className={styles.cards}>
        <img src="/icons/partnership-card.svg" alt="John Lewis Partnership Credit Card" />
        <img src="/icons/apple-pay.svg" alt="Apple Pay" />
        <img src="/icons/visa.svg" alt="Visa" />
        <img src="/icons/master-card.svg" alt="MasterCard" />
      </div>
    </div>
  );
};

export default PaymentCards;
